/**
 * Footer JavaScript
 * Mobile menu accordion functionality
 * Performance optimized, modular JS
 */

(function() {
  'use strict';

  class Footer {
    constructor() {
      this.footer = document.querySelector('[data-footer]');
      if (!this.footer) return;
      
      this.isMobile = window.innerWidth <= 749;
      this.init();
      this.setupResize();
    }

    init() {
      if (this.isMobile) {
        this.setupAccordion();
      } else {
        this.removeAccordion();
      }
    }

    setupAccordion() {
      const menuButtons = this.footer.querySelectorAll('[data-footer-menu-toggle]');
      
      menuButtons.forEach(button => {
        const menu = button.closest('.footer__menu');
        if (!menu) return;
        
        // Set initial state
        menu.setAttribute('data-footer-menu-open', 'false');
        button.setAttribute('aria-expanded', 'false');
        
        // Add click handler
        button.addEventListener('click', () => {
          const isOpen = menu.getAttribute('data-footer-menu-open') === 'true';
          
          if (isOpen) {
            this.closeMenu(menu, button);
          } else {
            this.openMenu(menu, button);
          }
        });
      });
    }

    openMenu(menu, button) {
      menu.setAttribute('data-footer-menu-open', 'true');
      button.setAttribute('aria-expanded', 'true');
    }

    closeMenu(menu, button) {
      menu.setAttribute('data-footer-menu-open', 'false');
      button.setAttribute('aria-expanded', 'false');
    }

    removeAccordion() {
      const menus = this.footer.querySelectorAll('.footer__menu');
      menus.forEach(menu => {
        menu.removeAttribute('data-footer-menu-open');
        const button = menu.querySelector('[data-footer-menu-toggle]');
        if (button) {
          button.setAttribute('aria-expanded', 'true');
        }
      });
    }

    setupResize() {
      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          const wasMobile = this.isMobile;
          this.isMobile = window.innerWidth <= 749;
          
          if (wasMobile !== this.isMobile) {
            this.init();
          }
        }, 250);
      });
    }
  }

  // Initialize footer when DOM is ready
  function initFooter() {
    new Footer();
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFooter);
  } else {
    initFooter();
  }

  // Re-initialize on section load (for theme editor)
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      const footer = event.detail.container.querySelector('[data-footer]');
      if (footer) {
        new Footer();
      }
    });
  }
})();

